import SkinFactory from "../../../core/ui/SkinFactory";
import FileTreeNode from "../model/FileTreeNode";
import FileExplorerItemMediator from "../view/FileExplorerItemMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class FileExplorerItemFactory {
    constructor(mediatorManager) {
        this._mediatorManager = mediatorManager;
    }

    /**
     * Creates a file explorer item from a file tree node
     * @param {FileTreeNode} fileTreeNode 
     * @param {Object} skinKeyRegistry The skin key registry to instantiate the item skin from (e.g. LaptopSkinKeyRegistry)
     * @returns {FileExplorerItemMediator}
     */
    createItem(fileTreeNode, skinKeyRegistry) {
        const skin = SkinFactory.getSkin(skinKeyRegistry.FILE_EXPLORER_ITEM_SKIN);
        skin.customData = {
            fileTreeNode
        };

        // Asset work around - something in the assets seems scaled, causing a smaller height to be returned which is messing with the vertical layout
        skin.setBounds(skin.nominalBounds.x, skin.nominalBounds.y, skin.nominalBounds.width, skin.nominalBounds.height);

        return this._mediatorManager.createMediator(skin, skinKeyRegistry.FILE_EXPLORER_ITEM_SKIN);
    }
}